<ng-container *transloco="let t; read: 'credit-usage'">
  <h2 class="credit__header">{{ t('credit-usage') }}</h2>
  <ng-container>
    <div class="credit__report-row">
      {{ t('credit-usage') }}
      <xi-dropdown
        placeholder="{{ t('ai-studio') }}"
        select="single"
        [data]="creditType"
        [value]="dropdownValue"
        (onValueChange)="changeDisplay($event.detail.selected.id)"
      ></xi-dropdown>

      <xi-calendar
        [data]="calendarData"
        mode="relative"
        [checkedListId]="relativeRangeId"
        [popoutView]="true"
        [localization]="{
          firstInputPlaceholder: t('calendar.first-placeholder'),
          secondInputPlaceholder: t('calendar.second-placeholder'),
          startDate: t('calendar.start-date'),
          endDate: t('calendar.end-date'),
          errorString: t('calendar.error-string'),
          leftText: t('calendar.left-text'),
          rightText: t('calendar.right-text'),
          to: t('calendar.to'),
          custom: t('calendar.custom'),
          applyBtn: t('calendar.apply-button'),
          cancelBtn: t('calendar.cancel-button'),
          noSelection: t('calendar.no-selection'),
        }"
        (onValueChange)="onCalendarValueChange($event.detail)"
      ></xi-calendar>

      <div class="credit__button-row">
        <div class="credit__button-row_button">
          <xi-default-button [text]="t('preview')" (onClick)="generateReport()"></xi-default-button>

          <xi-default-button
            [text]="t('download')"
            (onClick)="downloadReport()"
          ></xi-default-button>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container>
    <div class="credit__report-counts">
      <div>
        {{ t('credit-balance', { balance }) }}
      </div>
      <div>
        {{ t('total-usage', { usage: totalBalance }) }}
      </div>
    </div>
  </ng-container>

  <div class="permission-table__container">
    <table mat-table [dataSource]="dataSource" class="permission-table__table">
      <ng-container matColumnDef="email">
        <th class="permission-table__name-header" mat-header-cell *matHeaderCellDef>
          {{ t('email') }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.user_email }}
        </td>
      </ng-container>

      <ng-container matColumnDef="usage">
        <th mat-header-cell *matHeaderCellDef>
          <div class="permission-table__table-header-content">
            <div class="permission-table__table-header-border"></div>
            <span>{{ t('credits-used') }}</span>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.values[0].balance_type_decrement_amount }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
</ng-container>
